// extracted by mini-css-extract-plugin
export default {"header":"dashboard_header__header--3h7+","h1":"dashboard_header__h1--njT7","nav":"dashboard_header__nav--BJh1"};